import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { ssoClient } from "@better-auth/sso/client";

import type { auth } from "@/lib/auth";

export const authClient = createAuthClient({
  plugins: [ssoClient(), inferAdditionalFields<typeof auth>()],
});
